module.exports = __webpack_public_path__ + "static/img/a059.ff418ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a059.jpg
// module id = xRJt
// module chunks = 0